/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as VelVelIdImport } from './routes/vel/$velId'
import { Route as VelVelIdIndexImport } from './routes/vel/$velId/index'
import { Route as VelVelIdPlacePlaceIdImport } from './routes/vel/$velId/place/$placeId'
import { Route as VelVelIdPlacePlaceIdIndexImport } from './routes/vel/$velId/place/$placeId/index'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const VelVelIdRoute = VelVelIdImport.update({
  id: '/vel/$velId',
  path: '/vel/$velId',
  getParentRoute: () => rootRoute,
} as any)

const VelVelIdIndexRoute = VelVelIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VelVelIdRoute,
} as any)

const VelVelIdPlacePlaceIdRoute = VelVelIdPlacePlaceIdImport.update({
  id: '/place/$placeId',
  path: '/place/$placeId',
  getParentRoute: () => VelVelIdRoute,
} as any)

const VelVelIdPlacePlaceIdIndexRoute = VelVelIdPlacePlaceIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VelVelIdPlacePlaceIdRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/vel/$velId': {
      id: '/vel/$velId'
      path: '/vel/$velId'
      fullPath: '/vel/$velId'
      preLoaderRoute: typeof VelVelIdImport
      parentRoute: typeof rootRoute
    }
    '/vel/$velId/': {
      id: '/vel/$velId/'
      path: '/'
      fullPath: '/vel/$velId/'
      preLoaderRoute: typeof VelVelIdIndexImport
      parentRoute: typeof VelVelIdImport
    }
    '/vel/$velId/place/$placeId': {
      id: '/vel/$velId/place/$placeId'
      path: '/place/$placeId'
      fullPath: '/vel/$velId/place/$placeId'
      preLoaderRoute: typeof VelVelIdPlacePlaceIdImport
      parentRoute: typeof VelVelIdImport
    }
    '/vel/$velId/place/$placeId/': {
      id: '/vel/$velId/place/$placeId/'
      path: '/'
      fullPath: '/vel/$velId/place/$placeId/'
      preLoaderRoute: typeof VelVelIdPlacePlaceIdIndexImport
      parentRoute: typeof VelVelIdPlacePlaceIdImport
    }
  }
}

// Create and export the route tree

interface VelVelIdPlacePlaceIdRouteChildren {
  VelVelIdPlacePlaceIdIndexRoute: typeof VelVelIdPlacePlaceIdIndexRoute
}

const VelVelIdPlacePlaceIdRouteChildren: VelVelIdPlacePlaceIdRouteChildren = {
  VelVelIdPlacePlaceIdIndexRoute: VelVelIdPlacePlaceIdIndexRoute,
}

const VelVelIdPlacePlaceIdRouteWithChildren =
  VelVelIdPlacePlaceIdRoute._addFileChildren(VelVelIdPlacePlaceIdRouteChildren)

interface VelVelIdRouteChildren {
  VelVelIdIndexRoute: typeof VelVelIdIndexRoute
  VelVelIdPlacePlaceIdRoute: typeof VelVelIdPlacePlaceIdRouteWithChildren
}

const VelVelIdRouteChildren: VelVelIdRouteChildren = {
  VelVelIdIndexRoute: VelVelIdIndexRoute,
  VelVelIdPlacePlaceIdRoute: VelVelIdPlacePlaceIdRouteWithChildren,
}

const VelVelIdRouteWithChildren = VelVelIdRoute._addFileChildren(
  VelVelIdRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/vel/$velId': typeof VelVelIdRouteWithChildren
  '/vel/$velId/': typeof VelVelIdIndexRoute
  '/vel/$velId/place/$placeId': typeof VelVelIdPlacePlaceIdRouteWithChildren
  '/vel/$velId/place/$placeId/': typeof VelVelIdPlacePlaceIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/vel/$velId': typeof VelVelIdIndexRoute
  '/vel/$velId/place/$placeId': typeof VelVelIdPlacePlaceIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/vel/$velId': typeof VelVelIdRouteWithChildren
  '/vel/$velId/': typeof VelVelIdIndexRoute
  '/vel/$velId/place/$placeId': typeof VelVelIdPlacePlaceIdRouteWithChildren
  '/vel/$velId/place/$placeId/': typeof VelVelIdPlacePlaceIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/vel/$velId'
    | '/vel/$velId/'
    | '/vel/$velId/place/$placeId'
    | '/vel/$velId/place/$placeId/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/vel/$velId' | '/vel/$velId/place/$placeId'
  id:
    | '__root__'
    | '/'
    | '/vel/$velId'
    | '/vel/$velId/'
    | '/vel/$velId/place/$placeId'
    | '/vel/$velId/place/$placeId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  VelVelIdRoute: typeof VelVelIdRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  VelVelIdRoute: VelVelIdRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/vel/$velId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/vel/$velId": {
      "filePath": "vel/$velId.tsx",
      "children": [
        "/vel/$velId/",
        "/vel/$velId/place/$placeId"
      ]
    },
    "/vel/$velId/": {
      "filePath": "vel/$velId/index.tsx",
      "parent": "/vel/$velId"
    },
    "/vel/$velId/place/$placeId": {
      "filePath": "vel/$velId/place/$placeId.tsx",
      "parent": "/vel/$velId",
      "children": [
        "/vel/$velId/place/$placeId/"
      ]
    },
    "/vel/$velId/place/$placeId/": {
      "filePath": "vel/$velId/place/$placeId/index.tsx",
      "parent": "/vel/$velId/place/$placeId"
    }
  }
}
ROUTE_MANIFEST_END */
